import React from 'react'
import { VscSearch } from 'react-icons/vsc'
import { Link } from 'react-router-dom'
import salemap from './images/salemap.png'

const sale = () => {
    return (
        <>
            <div className="py-1">

                <div className="py-10 md:border-t-[.2rem] border-t-gray-100 md:mx-0 mx-5">
                    <h1 className='text-[#004A8B] text-[2.6rem] pt-2 md:ml-[22rem] high'>For Sale</h1>
                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] md:ml-[22rem] py-1  w-[4rem]"></div>
                </div>

                <div className=" bg-gray-100 py-10">
                    <div className="container  md:mx-[50px]">
                        <div class="grid grid-cols-12  ">

                            <div class="md:col-span-3 col-span-12 ml-0 md:ml-7 px-5">

                                <div className="md:w-[90%]  ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px] tracking-wider border-none border-gray-200 focus:outline-none' >
                                        <option value="" className=''>FOR SALE</option>
                                        <option value="">SOLD</option>
                                    </select>
                                </div>

                                <div className=" my-[1.2rem] md:w-[90%]  ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px]  border-none border-gray-200 focus:outline-none' >
                                        <option value="">STATE</option>
                                        <option value="">ACT</option>
                                        <option value="">NSW</option>
                                        <option value="">NT</option>
                                        <option value="">QLD</option>
                                        <option value="">TAS</option>
                                        <option value="">VIC</option>
                                        <option value="">WA</option>
                                    </select>
                                </div>
                                <div className=" md:w-[90%]   my-[.7rem]">
                                    <input type="text" placeholder='SUBRUB' className='py-3 px-2 w-full tracking-wider text-[13px] placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className="md:w-[90%]    my-[1.2rem] ">
                                    <select name="" id="" className='py-3 px-2 w-full text-[13px] tracking-widest border-none border-gray-200 focus:outline-none' >
                                        <option value="" className=''>PROPERTY TYPE</option>
                                        <option value="">Cotton</option>
                                        <option value="">Cropy</option>
                                        <option value="">Dairy</option>
                                        <option value="">Development</option>
                                        <option value="">Horticulture</option>
                                        <option value="">LiveStocks</option>
                                    </select>
                                </div>

                                <div className=" md:w-[90%]    my-[.7rem] ">
                                    <input type="text" placeholder='MIN PRICE' className=' py-3 px-2 w-full tracking-widest text-[13px]  placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%]  py-2">
                                    <input type="text" placeholder='MAX PRICE' className='py-3 px-2 w-full tracking-widest text-[13px]   placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%]   my-[.7rem]">
                                    <input type="text" placeholder='MIN AREA' className='py-3 px-2 w-full tracking-widest text-[13px]   placeholder-black focus:outline-none focus:border-none' />
                                </div>
                                <div className=" md:w-[90%]  py-2">
                                    <input type="text" placeholder='MAX AREA' className='py-3 px-2 w-full tracking-widest text-[13px]    placeholder-black focus:outline-none focus:border-none' />
                                </div>

                                <div className="bg-[#004A8B] hover:bg-[#B6D0B3] text-white md:w-[90%]   text-[13px] font-black my-2">
                                    <button className='py-2  px-2'>
                                        <Link to='/Forsale' className='flex tracking-widest text-[13px]'><span className='py-1'>SEARCH NOW </span><VscSearch className='text-[1.7rem] ml-[11rem] md:ml-[4rem]' /></Link>
                                    </button>
                                </div>

                            </div>

                            <div class="md:col-span-9  col-span-12">
                                <div className="md:mx-0 mx-2">
                                    <img src={salemap} alt="map" className='md:h-[86vh] h-[50vh] md:w-[94%] w-[100%] hover:opacity-70 hover:bg-gray-200 transition duration-500 ease-in-out sm:hover:bg-transparent sm:hover:opacity-100' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default sale